import { DisplayableProduct } from "../../../../../store/api/upsellApi";
import React, { ReactElement } from "react";
import { Box, Card, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";

export function Product<P extends DisplayableProduct>({
  product,
  leftAction,
  rightAction,
}: {
  product: P;
  leftAction?: ReactElement;
  rightAction?: ReactElement;
}) {
  return (
    <Card
      sx={{
        display: "grid",
        gridTemplateColumns: "auto 1fr auto",
        gridTemplateAreas: `
        "left-action product right-action"
        `,
        borderColor: "divider",
      }}
    >
      {leftAction ? (
        <Box
          sx={{
            gridArea: "left-action",
            mx: 1,
            height: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          {leftAction}
        </Box>
      ) : (
        <Box sx={{ gridArea: "left-action", ml: 1 }} />
      )}
      <Box sx={{ gridArea: "product", py: 0.5 }}>
        <Typography>{product.name}</Typography>
        <Typography sx={{ color: "text.secondary", fontSize: "0.9em" }}>#{product.id}</Typography>
      </Box>
      {rightAction ? (
        <Box
          sx={{
            gridArea: "right-action",
            background: grey["50"],
            height: "100%",
            display: "flex",
          }}
        >
          {rightAction}
        </Box>
      ) : (
        <Box sx={{ gridArea: "right-action", mr: 1 }} />
      )}
    </Card>
  );
}
